import { z } from 'zod/v4';

// The API sends `color`; consumers (web-tags-collection) expect `colorBackground`.
export const AddressBookTagContract = z
    .object({
        id: z.number(),
        name: z.string(),
        color: z.string(),
    })
    .transform(({ color, ...rest }) => ({ ...rest, colorBackground: color }));

export const AddressBookTagCollectionResponseSchema = z.object({
    data: z.array(AddressBookTagContract),
});

export type AddressBookTag = z.infer<typeof AddressBookTagContract>;
